import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Timeline } from '.';
import { TimelineItem } from './view/Default/components';
import { WrapperHorizontal, WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "timeline"
    }}>{`Timeline`}</h1>
    <p>{`Component designed for visualization of history`}</p>
    <h2 {...{
      "id": "basic-timeline"
    }}>{`Basic Timeline`}</h2>
    <Playground __position={0} __code={'<Timeline>\n  <TimelineItem>Item 1</TimelineItem>\n  <TimelineItem>Item 2</TimelineItem>\n  <TimelineItem>Item 3</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem mdxType="TimelineItem">Item 1</TimelineItem>
        <TimelineItem mdxType="TimelineItem">Item 2</TimelineItem>
        <TimelineItem mdxType="TimelineItem">Item 3</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "align-timeline"
    }}>{`Align Timeline`}</h2>
    <Playground __position={1} __code={'<WrapperVertical>\n  <Timeline align=\"right\">\n    <TimelineItem>Item 1</TimelineItem>\n    <TimelineItem>Item 2</TimelineItem>\n    <TimelineItem>Item 3</TimelineItem>\n  </Timeline>\n  <Timeline align=\"left\">\n    <TimelineItem>Item 1</TimelineItem>\n    <TimelineItem>Item 2</TimelineItem>\n    <TimelineItem>Item 3</TimelineItem>\n  </Timeline>\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Timeline align="right" mdxType="Timeline">
            <TimelineItem mdxType="TimelineItem">Item 1</TimelineItem>
            <TimelineItem mdxType="TimelineItem">Item 2</TimelineItem>
            <TimelineItem mdxType="TimelineItem">Item 3</TimelineItem>
        </Timeline>
        <Timeline align="left" mdxType="Timeline">
            <TimelineItem mdxType="TimelineItem">Item 1</TimelineItem>
            <TimelineItem mdxType="TimelineItem">Item 2</TimelineItem>
            <TimelineItem mdxType="TimelineItem">Item 3</TimelineItem>
        </Timeline>
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "custom-dot-for-timelineitem"
    }}>{`Custom dot for TimelineItem`}</h2>
    <Playground __position={2} __code={'<Timeline>\n  <TimelineItem\n    dot={\n      <div\n        style={{\n          height: \'10px\',\n          width: \'10px\',\n          backgroundColor: \'red\',\n          borderRadius: \'50%\',\n        }}\n      />\n    }\n  >{`item 1`}</TimelineItem>\n  <TimelineItem>{`item 2`}</TimelineItem>\n  <TimelineItem dot={<p>X</p>}>{`item 3`}</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem dot={<div style={{
          height: '10px',
          width: '10px',
          backgroundColor: 'red',
          borderRadius: '50%'
        }} />} mdxType="TimelineItem">{`item 1`}</TimelineItem>
        <TimelineItem mdxType="TimelineItem">{`item 2`}</TimelineItem>
        <TimelineItem dot={<p>X</p>} mdxType="TimelineItem">{`item 3`}</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "opposite-content-for-timelineitem"
    }}>{`Opposite content for TimelineItem`}</h2>
    <Playground __position={3} __code={'<Timeline>\n  <TimelineItem oppositeContent=\"Opposite content\">Item 1</TimelineItem>\n  <TimelineItem>Item 2</TimelineItem>\n  <TimelineItem>Item 3</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem oppositeContent="Opposite content" mdxType="TimelineItem">Item 1</TimelineItem>
        <TimelineItem mdxType="TimelineItem">Item 2</TimelineItem>
        <TimelineItem mdxType="TimelineItem">Item 3</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "custom-types-of-timelineitem"
    }}>{`Custom types of TimelineItem`}</h2>
    <Playground __position={4} __code={'<Timeline>\n  <TimelineItem type=\"default\">Item 1</TimelineItem>\n  <TimelineItem type=\"primary\">Item 2</TimelineItem>\n  <TimelineItem type=\"success\">Item 3</TimelineItem>\n  <TimelineItem type=\"warning\">Item 4</TimelineItem>\n  <TimelineItem type=\"error\">Item 5</TimelineItem>\n  <TimelineItem type=\"info\">Item 6</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem type="default" mdxType="TimelineItem">Item 1</TimelineItem>
        <TimelineItem type="primary" mdxType="TimelineItem">Item 2</TimelineItem>
        <TimelineItem type="success" mdxType="TimelineItem">Item 3</TimelineItem>
        <TimelineItem type="warning" mdxType="TimelineItem">Item 4</TimelineItem>
        <TimelineItem type="error" mdxType="TimelineItem">Item 5</TimelineItem>
        <TimelineItem type="info" mdxType="TimelineItem">Item 6</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "unique-timelineitem"
    }}>{`Unique TimelineItem`}</h2>
    <Playground __position={5} __code={'<Timeline>\n  <TimelineItem unique=\"YES\">Item 1</TimelineItem>\n  <TimelineItem unique={20}>Item 2</TimelineItem>\n  <TimelineItem>Item 3</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem unique="YES" mdxType="TimelineItem">Item 1</TimelineItem>
        <TimelineItem unique={20} mdxType="TimelineItem">Item 2</TimelineItem>
        <TimelineItem mdxType="TimelineItem">Item 3</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "align-timelineitem"
    }}>{`Align TimelineItem`}</h2>
    <Playground __position={6} __code={'<Timeline>\n  <TimelineItem align=\"left\">Item 1</TimelineItem>\n  <TimelineItem align=\"left\">Item 2</TimelineItem>\n  <TimelineItem align=\"right\">Item 3</TimelineItem>\n</Timeline>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Timeline,
      TimelineItem,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Timeline mdxType="Timeline">
        <TimelineItem align="left" mdxType="TimelineItem">Item 1</TimelineItem>
        <TimelineItem align="left" mdxType="TimelineItem">Item 2</TimelineItem>
        <TimelineItem align="right" mdxType="TimelineItem">Item 3</TimelineItem>
    </Timeline>
    </Playground>
    <h2 {...{
      "id": "known-bugs"
    }}>{`Known bugs`}</h2>
    <ul>
      <li parentName="ul">{`prop `}<inlineCode parentName="li">{`type`}</inlineCode>{` in `}<inlineCode parentName="li">{`TimelineItem`}</inlineCode>{` does not work`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      